import { FIXED_EXCHANGE_RATE, formatDualPriceValue } from './getPrices';

type CurrencyData = {
    integerValue: string;
    decimalValue: string;
    currencyLabel: string;
};

type GetPrices = (
    value: number | undefined,
    currencyCode: string | undefined
) => { primaryPrice?: CurrencyData; secondaryPrice?: CurrencyData };

const getPrices: GetPrices = (value, currencyCode) => {
    if (value === undefined) return {};
    const eurValue = currencyCode === 'EUR' ? value : value / FIXED_EXCHANGE_RATE;
    const hrkValue = currencyCode === 'HRK' ? value : value * FIXED_EXCHANGE_RATE;

    const eurValueData = formatDualPriceValue(eurValue).split(',');
    const hrkValueData = formatDualPriceValue(hrkValue).split(',');

    const eurPrice = {
        integerValue: eurValueData[0],
        decimalValue: eurValueData?.[1] ?? '',
        currencyLabel: `€`,
    };
    const hrkPrice = {
        integerValue: hrkValueData[0],
        decimalValue: hrkValueData?.[1] ?? '',
        currencyLabel: 'kn',
    };

    const primaryCurrency = currencyCode;
    return primaryCurrency === 'HRK'
        ? {
              primaryPrice: hrkPrice,
              secondaryPrice: eurPrice,
          }
        : {
              primaryPrice: eurPrice,
              secondaryPrice: hrkPrice,
          };
};

type GetPricesReturnProps = {
    comparisonPriceProps?: CurrencyData;
    currentPriceProps?: CurrencyData;
    secondaryCurrencyComparisonPriceProps?: CurrencyData;
    secondaryCurrencyPriceProps?: CurrencyData;
};

type GetPricesProps = {
    price?: number;
    comparison?: number;
    currencyCode?: string;
};

export const getSkapaPriceProps = (props: GetPricesProps): GetPricesReturnProps => {
    const { price, comparison, currencyCode } = props;

    if (currencyCode !== 'EUR' && currencyCode !== 'HRK') {
        throw new Error("Invalid currencyCode. Supported values: 'HRK' | 'EUR'");
    }
    if (price === undefined && comparison === undefined) {
        return {};
    }

    let prices, comparisonPrices;
    if (price !== undefined) {
        prices = getPrices(price, currencyCode);
    }
    if (comparison !== undefined) {
        comparisonPrices = getPrices(comparison, currencyCode);
    }
    return {
        ...(prices && {
            currentPriceProps: prices.primaryPrice,
            secondaryCurrencyPriceProps: prices.secondaryPrice,
        }),
        ...(comparisonPrices && {
            comparisonPriceProps: comparisonPrices.primaryPrice,
            secondaryCurrencyComparisonPriceProps: comparisonPrices.secondaryPrice,
        }),
    };
};
